const TradingSessionResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'tradingsessions/:id',
        apiRequestParams.defaults(),
        {
            // 'query' to GET /tradingsessions (with ?deviceID filter)
            // 'save' to POST /tradingsessions and start a new session
            // 'remove' to DELETE /tradingsessions/{id} and start a new session,
            // 'get' to GET /tradingsessions/{id} and show info about the session
            saveEvent: {
                url: appConfig.apiBaseUrl + 'tradingsessionevents',
                method: 'POST',
            },

            getSummary: {
                url: appConfig.apiBaseUrl + 'tradingsessionsummaries/:id',
                method: 'GET',
                isArray: false,
            },
        }
    );
};

module.exports = TradingSessionResource;
